import React, { useEffect, useState } from 'react';
import CommonBreadCrumb from 'components/commonBreadCrumb/CommonBreadCrumb';
import { getCustomerComplaints, getUpdateComplaintApi } from 'redux/actions/CustomerComplaints';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { roleAndPermissionEnum } from 'utils/rolesPermissionsEnum';
import { handlePermissions } from 'utils/utils';
import CustomerHeader from '../customers/CustomerHeader';
import { getCustomer } from 'redux/actions/UserCustomer';
import BillingDisputeCard from './ComplaintDetails';

function CustomerComplaintView() {
  const dispatch = useDispatch();
  const { state } = useLocation();
  const { id, name, demandProfileId } = state;

  const [value, setValue] = useState('1');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(1);
  const [status, setStatus] = useState('');

  // Selectors for userCustomer and userCustomerComplaints data
  const userCustomerData = useSelector((state) => state?.userCustomer?.userCustomer?.data);
  const userCustomerLoader = useSelector((state) => state?.userCustomer?.loading);
  const tableData = useSelector((state) => state?.userCustomerComplaints?.userCustomerComplaints?.data);
  const customerLoader = useSelector((state) => state?.userCustomerComplaints?.loading);

  console.log(userCustomerData, 'userCustomerData in CustomerComplaintView');
  console.log(tableData, 'tableData in CustomerComplaintView');

  // Filter data for API calls
  let customerFilterData = {
    id: demandProfileId,
    page: '',
    date: '',
    status: status,
    pageSize: '',
  };

  let complaintFilterData = {
    id: id,
    page: '',
    date: '',
    status: status,
    pageSize: '',
  };

  // Fetch data on component mount
  useEffect(() => {
    dispatch(getCustomer(customerFilterData)); // Fetch userCustomer data
    dispatch(getCustomerComplaints(complaintFilterData)); // Fetch customer complaints data
  }, [dispatch, demandProfileId, id, status]);

  const breadcrumbPaths = [
    { name: 'Tickets', url: -1 },
    { name: name, url: '' },
  ];

  const onClickStatusIcon = (data) => {
    if (data === 'Activate') {
      const profileData = {
        customerId: demandProfileId,
        id: id,
        data: {
          status: 'Active',
        },
      };
      // Dispatch action to update status (if needed)
    } else if (data === 'Block') {
      const profileData = {
        customerId: demandProfileId,
        id: id,
        data: {
          status: 'Blocked',
        },
      };
      // Dispatch action to update status (if needed)
    } else if (data === 'Unblock') {
      const profileData = {
        customerId: demandProfileId,
        id: id,
        data: {
          status: 'Active',
        },
      };
      // Dispatch action to update status (if needed)
    }
  };

  const handleUpdateComplaint = (demandProfileId, status, comment) => {
    const payload = {
      id: demandProfileId,
      status,
      comment,
    };
    dispatch(getUpdateComplaintApi(payload)); // Dispatch the Redux action to update the complaint
  };

  // Roles and permissions
  const roleAndPermissions = useSelector(
    (state) => state?.getRolesAndPermissions?.rolesAndPermissions
  );
  const customerRoleEnum = roleAndPermissionEnum.customer;
  const accessForAll = handlePermissions(
    roleAndPermissions,
    customerRoleEnum.moduleKey,
    {
      defaultAllAccess: customerRoleEnum.all,
    }
  );

  const accessForBlock = handlePermissions(
    roleAndPermissions,
    customerRoleEnum.moduleKey,
    {
      defaultAllAccess: customerRoleEnum.block,
    }
  );

  const hasViewMoreIcon = accessForAll || accessForBlock;

  return (
    <div className="marginTop">
      <CommonBreadCrumb paths={breadcrumbPaths} />
      <CustomerHeader
        tableData={userCustomerData} // Pass userCustomer data to CustomerHeader
        tabName="customer"
        onClickStatusIcon={onClickStatusIcon}
        loader={userCustomerLoader} // Pass userCustomer loader
        statusChange={hasViewMoreIcon}
      />
      <BillingDisputeCard tableData={tableData} onUpdateComplaint={handleUpdateComplaint}/>
    </div>
  );
}

export default CustomerComplaintView;